






















import Vue from 'vue';
import { SetActivity } from '../models/exercise-activity.model';

export default Vue.extend({
  // Using v-bind.sync="set", object's individual properties become props
  props: {
    weight: Number,
    reps: Number,
    rpe: Number,
  },
  data: function() {
    return {
      local: {
        ...(this.$props as SetActivity),
      },
    };
  },
  methods: {
    valueChange(prop: keyof SetActivity) {
      // emit individual property change
      this.$emit(`update:${prop}`, this.local[prop] || 0);
      // when the set has updated at all, used in parent .once
      // this.$emit('update:set');
    },
  },
});
